import React from "react";

export function useSchools() {
    const [value, setValue] = React.useState([])
    const handleChange = id => {
        const valueUpdated = value.map(item => (item.map(item2 =>  {
            if (item2.id === id) {
                item2.value = !item2.value
            }
            return item2
        })))
        setValue(valueUpdated)
    }
    return { value, handleChange, setValue }
}